// 乘法 精度换算
const i2Multiply = function (n1, n2) {
  const num1 = Number(n1) || 0
  const num2 = Number(n2) || 0
  let m = 0
  let r1 = num1.toString()
  let r2 = num2.toString()
  try {
    m += r1.split('.')[1].length
  } catch (e) {}
  try {
    m += r2.split('.')[1].length
  } catch (e) {}
  return Number(r1.replace('.', '')) * Number(r2.replace('.', '')) / Math.pow(10, m)
}

export default i2Multiply
